import React from 'react';
import { Download } from 'lucide-react';
import { Button, Card } from 'shared-portal-components-v2';

import { MIN_LEN } from '@/constants';
import SixDetailSectionHeader from '@/components/molecules/SixDetailSectionHeader/SixDetailSectionHeader';
import SixDetailActivityCard from '@/components/molecules/SixDetailActivityCard/SixDetailActivityCard';

export interface SixDetailActivityItemModel {
  id: string;
  title: string;
  actorLabel: string;
  timestampLabel: string;
  badgeLabel: string;
}

export interface SixDetailActivityPanelProps {
  activityCards: SixDetailActivityItemModel[];
  onExport?: () => void;
  className?: string;
}

export default function SixDetailActivityPanel({
  activityCards,
  onExport,
  className,
}: SixDetailActivityPanelProps) {
  const activityCountLabel = `${activityCards.length} activities`;

  return (
    <div className={className}>
      <div className="space-y-4 sm:space-y-6">
        <SixDetailSectionHeader
          title="Recent Activity"
          countLabel={activityCountLabel}
          action={onExport === undefined ? undefined : (
            <Button variant="tertiary" className="w-full sm:w-auto border-border border rounded-md" onClick={onExport}>
              <Download className="h-3 w-3 mr-1" />
              Export
            </Button>
          )}
        />

        <div className="space-y-3">
          {activityCards.length === MIN_LEN ? (
            <Card className="p-6">
              <div className="text-sm text-muted-foreground">No activity.</div>
            </Card>
          ) : (
            activityCards.map((activityCard) => (
              <SixDetailActivityCard
                key={activityCard.id}
                title={activityCard.title}
                actorLabel={activityCard.actorLabel}
                timestampLabel={activityCard.timestampLabel}
                badgeLabel={activityCard.badgeLabel}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}
